export const config = {
    langList: {
        ko: { key: 'korean', langName: '한국어', flag: 'SouthKorea.png', },
        en: { key: 'english', langName: '영어', flag: 'USA.png', },
        ja: { key: 'japanese', langName: '일본어', flag: 'Japan.png', },
        zhTW: { key: 'traditional', langName: '번체(대만)', flag: 'Taiwan.png', },
        zhCN: { key: 'simplified', langName: '간체(중국)', flag: 'China.png', },
    },
    fallbackLang: 'en',
    apiServer: '/api/',
};

